import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5">
      <div className="min-w-0">
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 flex items-center gap-2">
          <span className="w-1 h-5 md:h-6 rounded-full bg-accent-500"></span>
          {title}
        </h2>
        {subtitle && (
          <p className="mt-1.5 text-sm text-foreground-500 truncate">{subtitle}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel || "查看更多"}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}